import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeftDouble18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.53044 4.53033L8.46978 3.46967L2.93945 9L8.46978 14.5303L9.53044 13.4697L5.06077 9L9.53044 4.53033Z'
      fill='currentColor'
    />
    <path
      d='M14.5304 4.53033L13.4698 3.46967L7.93945 9L13.4698 14.5303L14.5304 13.4697L10.0608 9L14.5304 4.53033Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeftDouble18.displayName = 'ChevronLeftDouble18';
export default ChevronLeftDouble18;
